import { Alert, Code, Text } from '@mantine/core'
import { IconLink } from '@tabler/icons-react'

/**
 * The notice a list page shows when a Signal Inbox link named one of its items (`?connector=`, `?queue=`).
 *
 * Found: which item was linked, and that it is marked below. Not found: that the page lists no such item NOW — the
 * signal may have ended as no longer tracked — so the whole list is never mistaken for the linked item's answer.
 */
export function LinkedFromSignal({ what, id, found }: { what: string; id: string; found: boolean }) {
  return (
    <Alert
      icon={<IconLink size={16} />}
      color={found ? 'blue' : 'gray'}
      variant="light"
      data-linked-notice={found ? 'found' : 'missing'}
    >
      <Text size="sm">
        {found ? (
          <>Opened from the Signal Inbox for {what} <Code>{id}</Code>, marked below.</>
        ) : (
          <>
            Opened from the Signal Inbox for {what} <Code>{id}</Code>, but nothing here is listed under that name
            now. The signal may have ended as no longer tracked; everything below is the whole list, not that {what}.
          </>
        )}
      </Text>
    </Alert>
  )
}

/** The mark on the linked item itself. */
export function LinkedMark() {
  return (
    <Text size="xs" c="blue" fw={600} data-linked="">
      Linked from the Signal Inbox
    </Text>
  )
}
